import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-title',
  templateUrl: './breadcrumb-title.component.html'
})
export class BreadcrumbTitleComponent {
  @Input() titulo: string = '';
}
